import type { Segment } from '@/generated/graphql';
import type { CompletedSegment } from '@/components/FlightSummary/Segment/resolver';
import segmentResolver from '@/components/FlightSummary/Segment/resolver';

const getSegmentsList = (legs): Array<Segment> =>
  legs?.map(({ segments }) => segments[0]);

interface Summary {
  isRoundTrip: boolean;
  isMultiTrip: boolean;
  segments: Array<CompletedSegment>;
}

export default function summaryResolver(legs): Summary {
  const segments = getSegmentsList(legs);
  const segmentParsed = segments?.map(segmentResolver);
  const isRoundTrip =
    segmentParsed?.length === 2 &&
    JSON.stringify(segmentParsed?.[0].departure) ===
      JSON.stringify(segmentParsed?.[1].destination) &&
    JSON.stringify(segmentParsed?.[1].departure) ===
      JSON.stringify(segmentParsed?.[0].destination);
  const isMultiTrip = segmentParsed?.length > 1 && !isRoundTrip;
  return {
    isRoundTrip: isRoundTrip,
    isMultiTrip: isMultiTrip,
    segments: segmentParsed,
  };
}
